import { isSome } from '@mbscan/shared'
import { createRouter, Navigate, RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'

import { initializeMonitoring } from './lib/monitoring'
import { trackVisualViewportHeight } from './lib/viewport-height'
import { routeTree } from './routeTree.gen'

initializeMonitoring()
trackVisualViewportHeight()

const isInternetExplorer = /MSIE|Trident/.test(window.navigator.userAgent)
if (isInternetExplorer && window.location.pathname !== '/ie') {
  window.location.replace('/ie')
}

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <Navigate to="/" replace />,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root')
if (!isSome(container)) {
  throw new Error('#root element not found')
}

createRoot(container).render(<RouterProvider router={router} />)
